<template>
  <div style="height: 100%">
    <RolesBeepizList
      v-if="props.selectedUniverse === 'beepiz'"
      :rolesList="props.rolesList"
      :selectedRole="props.selectedRole"
      @handleSelectRole="handleSelectRole"
    />
    <div v-else class="modal-roles-container">
      <div
        v-for="role in props.rolesList"
        @click="handleSelectRole(role)"
        :class="{ active: getRoleName() == role.name }"
        :key="role.name"
      >
        <span v-if="$te('users.roles.id_' + role.id)">{{
          $t("users.roles.id_" + role.id)
        }}</span>
        <span v-else>{{ role.display_name }}</span>
        <font-awesome-icon icon="check" />
        <p
          v-if="$te('users.roles.description_' + role.id)"
          v-html="$t('users.roles.description_' + role.id)"
        ></p>
        <p v-else v-html="role.description"></p>
      </div>
    </div>
  </div>
</template>

<script>
import RolesBeepizList from "../../components/roles/beepiz-list.vue";

export default {
  beforeCreate: function () {},
  beforeDestroy: function () {},
  beforeMount: function () {},
  beforeUpdate: function () {},
  components: {
    RolesBeepizList,
  },
  computed: {},
  created: function () {},
  destroyed: function () {},
  methods: {
    getRoleName() {
      if (this.props.selectedRole) {
        return this.props.selectedRole.name;
      }
      return null;
    },
    handleSelectRole(role) {
      this.props.events.selectRole(role);
    },
  },
  mounted: function () {},
  name: "RolesList",
  props: {
    props: {
      type: Object,
      default() {
        return {};
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.list-group {
  border: 1px solid #d1d5db;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: stretch;
}
.list-group-item {
  flex: 1;
  cursor: pointer;
}
.list-group-item:not(:last-child) {
  border-bottom: 1px solid #d1d5db;
}
.role-box {
  border: 1px solid #d1d5db;
  height: 100%;
  position: relative;
  margin-left: -1px;
}
</style>



// WEBPACK FOOTER //
// src/views/users/RolesList.vue